import React from "react";
import { NavLink } from "react-router-dom";
import { signup } from "../api";
import { toast } from "react-toastify";

import "./Signup.css";

class Signup extends React.Component {
  state = {
    username: "",
    email: "",
    password: "",
  };

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  handleFormSubmit = async (event) => {
    event.preventDefault();

    const { username, password, email } = this.state;
    await signup(username, email, password);
    toast.dark(`Your account was created successfully!`);
    this.props.history.push("/");
  };

  render() {
    const { username, password, email } = this.state;
    return (
      <main className="box">

        <form className="signupFormBox" onSubmit={this.handleFormSubmit}>
        <div className="teste">
          <NavLink
            style={{ textDecoration: "none", color: "black" }}
            to={"/login"}
          >
           <p>X</p>
          </NavLink>
        </div>
          <div className="signupBox">
            <label>Username</label>
            <input
              autocomplete="off"
              type="text"
              name="username"
              value={username}
              onChange={this.handleChange}
            />

            <label>Email</label>
            <input
              autocomplete="off"
              type="email"
              name="email"
              value={email}
              onChange={this.handleChange}
            />

            <label>Password</label>
            <input
              autocomplete="off"
              type="password"
              name="password"
              value={password}
              onChange={this.handleChange}
            />

            <button>Create Account</button>
          </div>
        </form>
      </main>
    );
  }
}

export default Signup;
